import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AlertService } from '../../services/alert.service';
import { WatchfaceService } from '../../services/watchface.service';

import { environment } from '../../../environments/environment';

@Component({
    selector: 'watchface-secret',
    templateUrl: './watchface-secret.component.html',
    styleUrls: ['./watchface-secret.component.scss']
})
export class WatchfaceSecretComponent implements OnInit, OnDestroy {

    watchfacesStore: string;

    watchfaceId!: string | null;

    secret!: string | null;

    approve!: boolean;

    reject!: boolean;

    progress!: boolean;

    watchface: any;

    constructor(
        private route: ActivatedRoute,
        private alertService: AlertService,
        private watchfaceService: WatchfaceService
    ) {
        this.watchfacesStore = environment.watchfacesStore;
    }

    ngOnInit() {
        this.route.paramMap.subscribe(
            (params) => {
                this.watchfaceId = params.get('watchfaceId');
                this.secret = params.get('secret');
                this.getWatchface();
            }
        );
        this.route.data.subscribe(
            (data) => {
                this.approve = data['approve'] === true;
                this.reject = data['reject'] === true;
            }
        );
    }

    ngOnDestroy() {
    }

    getWatchface() {
        if (this.watchfaceId == null) return;
        this.progress;
        this.watchfaceService.getPublicWatchface(this.watchfaceId).subscribe({
            next: (value: any) => {
                console.log('WatchfaceSecretComponent.getWatchface.watchfaceService.getPublicWatchface.value', value);
                this.progress;
                this.watchface = value;
            },
            error: (error: any) => {
                console.log('WatchfaceSecretComponent.getWatchface.watchfaceService.getPublicWatchface.error', error);
                this.progress;
                this.alertService.danger('Error');
            }
        });
    }

    clickApproveWatchface() {
        if (this.secret == null) return;
        this.progress = true;
        this.watchfaceService.approveWatchfaceWithSecret(this.watchface.id, this.secret).subscribe({
            next: (value: any) => {
                console.log('WatchfaceSecretComponent.clickApproveWatchface.watchfaceService.approveWatchfaceWithSecret.value', value);
                this.progress = false;
                this.alertService.success('Success');
                this.watchface.status = 'APPROVED';
            },
            error: (error: any) => {
                console.log('WatchfaceSecretComponent.clickApproveWatchface.watchfaceService.approveWatchfaceWithSecret.error', error);
                this.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    clickRejectWatchface() {
        if (this.secret == null) return;
        this.progress = true;
        this.watchfaceService.rejectWatchfaceWithSecret(this.watchface.id, this.secret).subscribe({
            next: (value: any) => {
                console.log('WatchfaceSecretComponent.clickRejectWatchface.watchfaceService.rejectWatchfaceWithSecret.value', value);
                this.progress = false;
                this.alertService.success('Success');
                this.watchface.status = 'REJECTED';
            },
            error: (error: any) => {
                console.log('WatchfaceSecretComponent.clickRejectWatchface.watchfaceService.rejectWatchfaceWithSecret.error', error);
                this.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
